import React from "react";
import PluginRegistry from "../../pluginsInfrastructure/PluginRegistry";
import {
  ComponentToBeRegistered,
  Placeholder,
  PlaceholderPlugin,
  PluginEnableContext,
} from "../../pluginsInfrastructure/PluginRegistryTypes";
import loadable from "@loadable/component";
import { PaypalPaylaterBuilderProps } from "./PaypalPayLaterBuilder/PaypalPayLaterBuilder";
import { payments } from "../pluginOwners";

export const PaypalComponent: ComponentToBeRegistered<PaypalPaylaterBuilderProps> = {
  placeholder: Placeholder.AfterPricing,
  Component: loadable<PaypalPaylaterBuilderProps>(() =>
    import("./PaypalPayLaterBuilder/PaypalPayLaterBuilder")
  ),
  name: "PaypalComponent",
  enable: (context: PluginEnableContext, parentComponents: string[]) => {
    const {
      pageProps: { locale },
    } = context;
    return ["en-US"].includes(locale);
  },
};

export const paypal: PlaceholderPlugin = {
  init(pluginRegistry: PluginRegistry) {
    pluginRegistry.addComponent(this, PaypalComponent);
  },
  pluginOwner: payments,
};
